import { cn } from "@/lib/utils";
import { Sparkle } from "./Sparkles";

export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = "center",
  sparkle = false,
  tone = "light",
  className,
}: {
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: "center" | "left";
  /** Kept for backward compat — the new design renders a small gold sparkle. */
  sparkle?: boolean;
  /** "dark" for use on the deep contrast sections (white title + soft intro). */
  tone?: "light" | "dark";
  className?: string;
}) {
  const dark = tone === "dark";
  return (
    <div
      className={cn(
        "relative max-w-3xl",
        align === "center" ? "mx-auto text-center" : "text-left",
        className,
      )}
    >
      {sparkle && <Sparkle className="absolute -top-5 right-0 h-7 w-7 md:-right-2" />}
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className={cn("h-section mt-2 font-bold text-balance", dark ? "text-white" : "text-ink")}>
        {title}
      </h2>
      {intro && (
        <p
          className={cn(
            "mt-4 text-base text-pretty md:text-lg",
            align === "center" && "mx-auto",
            dark ? "text-white/75" : "text-muted-foreground",
          )}
        >
          {intro}
        </p>
      )}
    </div>
  );
}
